import style from "./TableHead.module.scss";

export function TableHead() {
    return (
        <div className={style.head}>
            <div>Сума</div>
            <div>Дата поповнення</div>
            <div>Метод</div>
            <div>Промокод</div>
        </div>
    )
}